import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Container from "./Container";
import Aside from "./Aside";
import Main from "./Main";
import Banner from "./Banner";
import Content from "./Content";
var propTypes = {
  /** Set the maximum width of the content area */
  contentMaxWidth: PropTypes.string,

  /** Set the width of the sidebar */
  sidebarWidth: PropTypes.string,

  /** Should accept the `<Banner />` component */
  banner: PropTypes.node,

  /** Should accept any content */
  content: PropTypes.node,

  /** Should accept the `<Navigation />` component */
  navigation: PropTypes.node,

  /** Boolean check for `<NavigationSlim />` component */
  navigationSlim: PropTypes.bool,

  /** Should accept the `<AppFooter />` component */
  footer: PropTypes.node,
  theme: PropTypes.shape({
    app: PropTypes.oneOf(['dark'])
  }),
  backgroundColor: PropTypes.string
};
var defaultProps = {
  theme: {}
};
export function App(_ref) {
  var theme = _ref.theme,
      navigation = _ref.navigation,
      navigationSlim = _ref.navigationSlim,
      contentMaxWidth = _ref.contentMaxWidth,
      sidebarWidth = _ref.sidebarWidth,
      banner = _ref.banner,
      content = _ref.content,
      footer = _ref.footer,
      props = _objectWithoutProperties(_ref, ["theme", "navigation", "navigationSlim", "contentMaxWidth", "sidebarWidth", "banner", "content", "footer"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Container, props, React.createElement(Aside, {
    contentMaxWidth: contentMaxWidth,
    sidebarWidth: sidebarWidth,
    navigationSlim: navigationSlim
  }, navigation), React.createElement(Main, {
    contentMaxWidth: contentMaxWidth,
    sidebarWidth: sidebarWidth,
    navigationSlim: navigationSlim
  }, React.createElement(Banner, null, banner), React.createElement(Content, null, content), React.createElement("div", null, footer))));
}
App.darkTheme = {
  app: 'dark'
};
App.propTypes = propTypes;
App.defaultProps = defaultProps;
export default App;